import React from 'react';
import NavBar from '../../Component/NavBar/index'


const Header = () => {
return <NavBar/>
}

export default Header